/* eslint-disable no-underscore-dangle */
/* eslint-disable no-param-reassign */
/* eslint-disable no-loop-func */
import CommonTips, { CommonTipsType } from '@com/common-tips';
import i18n from '@i18next/i18n';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { ShapeType } from '@src/slide/infrastructure/module/dependent/shape-info/graphic-type';
import { dragBaseLogic } from './cp-ppt';
import { randomString } from './lib/ParserUtils';
import { uploadImageCrossDomain } from '@src/slide/infrastructure/module/dependent/image/lazy-load/lazy-image-components';
import ImageMetaExtractor from '@src/slide/infrastructure/module/dependent/image/image-toolkit/image-meta-extractor';
import { ImageEditManager } from './cp-image.new';
import { MenuType } from '@src/slide/domain/ui-model/constant/menu';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import { FillType } from '@src/slide/domain/ui-model/element-modeles/property/fill/fill.interface';
import { FONT_FILL_KEY } from '@src/slide/domain/ui-model/element-modeles/property/text/constants';
import { getNextSize } from '@src/slide/infrastructure/module/dependent/image/upload';
import { transaction } from '@src/slide/domain/slide-app';
import { ImageReplaceAction } from './cp-image.new/image-edit-manager/core/image-edit-manager.interface';
import type { IMenuManager } from '@src/slide/application/service/menu-manager/menu-manager.interface';
import Snackbar from '@tencent/dui/lib/components/Snackbar';

let menuManagerInstance: IMenuManager | undefined = undefined;

export const setMenuManagerDelegate = (menuManager) => {
    if (!menuManagerInstance) {
        menuManagerInstance = menuManager;
    }
};

/**
 * 插入图片元素
 * @param {*} imgs 待插入的图片
 */
export const addImagesInSlide = (imgs, slideModel) => {
    if (!imgs || imgs.length === 0) {
        return;
    }
    const types: UIModelType[] = [];
    for (let i = 0; i < imgs.length; i++) {
        const img = imgs[i];
        updateImageStyleInfo(img, i, slideModel?.presentationRef);
        types.push(UIModelType.IMAGE);
    }

    if (slideModel) {
        slideModel.addElement(types, imgs);
    }
};

export const addImageInSlide = (img, slideModel) => {
    if (slideModel) {
        slideModel.addElement([UIModelType.IMAGE], [img]);
    }
};

export const updateImageStyleInfo = (img, i, presentation) => {
    const { slideWidth, slideHeight } = presentation.props;

    const { nextWidth, nextHeight } = getNextSize(img, { slideWidth, slideHeight });

    const left = ((slideWidth - nextWidth) / 2) + (i * 10);
    const top = ((slideHeight - nextHeight) / 2) + (i * 10);

    img.style = {
        position: 'absolute',
        left,
        top,
        width: nextWidth,
        height: nextHeight,
        opacity: 1,
        bgShape: ShapeType.rect,
    };
    img.prstGeom = { prstGeomType: ShapeType.rect };   // 现在图片只支持矩形
};

export const replaceImage = (imgs, selModel) => {
    const action = ImageEditManager.getInstance().imageReplaceAction;
    ImageEditManager.getInstance().imageReplaceAction = 0; // 清除状态
    if (selModel.type === UIModelType.MULTIPLY) {
        transaction(() => {
            selModel.selectedModels?.forEach((child) => {
                if (child.type !== UIModelType.GROUP) {
                    let eleAction = action;
                    if (action === ImageReplaceAction.multi) {
                        eleAction = child.type === UIModelType.IMAGE
                            ? ImageReplaceAction.foreground
                            : ImageReplaceAction.background;
                    }
                    replaceSingleImage(imgs, child, eleAction);
                }
            });
        });
        return true;
    }
    return replaceSingleImage(imgs, selModel, action);
};

/**
 * 单个元素图片替换逻辑
 */
// eslint-disable-next-line complexity
export const replaceSingleImage = (imgs, selModel, imageReplaceAction?: number) => {
    imageReplaceAction = imageReplaceAction ?? ImageEditManager.getInstance().imageReplaceAction;
    if (imageReplaceAction === ImageReplaceAction.foreground && selModel.type === UIModelType.IMAGE) { // 前景图片替换操作
        transaction(() => {
            selModel.deleteDescription?.();

            if (selModel?.video && imgs?.[0].imageType === 'gif') {
                Snackbar.show({
                    message: i18n.t('视频封面暂不支持gif图'),
                    duration: 3000,
                });
            } else {
                selModel.handleReplacePicture(imgs);
            }
        });
        return true;
    }
    if (imageReplaceAction === ImageReplaceAction.background && selModel.type !== UIModelType.CONNECTOR) { // 背景图片替换
        if (imgs.length > 0 && imgs[0].src) {
            const image: any = {};
            image.src = imgs[0].src;
            const fillInfo = selModel.getBackgroundFill?.().getFillInfo();
            if (!fillInfo?.image) {
                transaction(() => {
                    selModel.deleteDescription?.();
                    selModel.getBackgroundFill().updateCurrentFill({ image });
                });
            } else {
                if (fillInfo.image.stretch) {
                    image.stretch = { ...fillInfo.image.stretch };
                }
                transaction(() => {
                    selModel.deleteDescription?.();
                    selModel.getImageFillEffect?.()?.handleResetPicture();
                    selModel.getBackgroundFill().updateCurrentFill({ image });
                });
            }
            return true;
        }
    }
    if (imageReplaceAction === ImageReplaceAction.text) { // 文字填充图片替换
        if (imgs.length > 0 && imgs[0].src && menuManagerInstance) {
            //  TODO：此处不正确的依赖了 menuManager，理想情况应该直接调用 model 的方法
            // 但是因为多选状态依旧依赖 menuManager 提供的多选设置方法，所以只能暂时先这样
            const { values, callback } = menuManagerInstance.toolbarMenu();
            const imageData = values?.[FONT_FILL_KEY]?.[FillType.ImageFill];
            const FillTypeToModelMap = {
                [FillType.NoFill]: FillType.NoFill,
                [FillType.SolidFill]: 'color',
                [FillType.GradualFill]: FillType.GradualFill,
                [FillType.ImageFill]: FillType.ImageFill,
                [FillType.PattFill]: FillType.PattFill,
            };
            const value = {
                [FillTypeToModelMap[FillType.ImageFill]]: {
                    ...imageData,
                    src: imgs[0].src,
                },
            };
            callback(MenuType.TOOLBAR, ActionType.FONT_FILL, value);
        }
        return true;
    }
};

/**
 * 是否是支持的图片类型
 */
const isSupportImageType4ParseCopyImgs = (type) => {
    let result = false;
    if (type === 'image/png'
        || type === 'image/jpeg'
        || type === 'image/gif'
        || type === 'image/bmp'
        || type === 'image/svg+xml'
        || type === 'image/tiff'
        || type === 'image/tif') {
        result = true;
    }
    return result;
};

// ---- pasteImageData  start ----
/**
 * @return {Function}
 * 插图接口
 * 场景：上传图片原文件、复制图片二进制到剪贴板
 */
const sucInsertImage = (
    imageSdkData,
    imageIndex,
    slideModel,
    callback,
) => async (attachmentId, url, type, width, height) => {
    if (!attachmentId) {
        return;
    }

    // image-components组件库升级，根据返回值构造图片数据结构
    const img: any = {
        height,
        width,
        src: url,
        imageName: attachmentId,
    };

    // 企业微信上传后无宽高，这里兜底，加载图片获取宽高
    if (!width && !height) {
        const size = await ImageMetaExtractor.extractUrl(url);
        img.width = size.width;
        img.height = size.height;
    }


    // 加入插件数据
    if (imageSdkData.addon) {
        img.addon = imageSdkData.addon;
    }

    if (callback) {
        callback([img]);
    } else {
        updateImageStyleInfo(img, imageIndex, slideModel.presentationRef);
        addImageInSlide(img, slideModel);
    }
};

const errInsertImage = () => () => {
    const tipContent = browser.isMac
        ? i18n.t('图片粘贴不成功。试试单独复制原图用Cmd+V粘贴，或将原图保存到电脑后点击“插入图片”。')
        : i18n.t('图片粘贴不成功。试试单独复制原图用Ctrl+V粘贴，或将原图保存到电脑后点击“插入图片”。');

    const commonTipsConfig = {
        message: tipContent,
        commonTipsType: CommonTipsType.INFO,
        block: false,
        closable: true,
    };

    CommonTips.getInstance().show(commonTipsConfig);
};

// 粘贴html中图片信息,  加了一个callback回调
export const pasteImageData = (slideModel, images: any[] = [], callback?) => {
    images.forEach((imageItem, imageIndex) => {
        let srclink = imageItem.url;
        if (srclink.length > 5 && srclink.substring(0, 5) !== 'https' && srclink.substring(0, 4) === 'http') {
            srclink = `https${srclink.substring(4)}`;
        }
        const attachmentId = `attachment-${new Date()}-${randomString()}`;
        const sucInsertImageFunc = sucInsertImage(imageItem, imageIndex, slideModel, callback);
        const errInsertImageFunc = errInsertImage();

        uploadImageCrossDomain(srclink, attachmentId, sucInsertImageFunc, errInsertImageFunc);
    });
};
// ---- pasteImageData end ----

/**
 * 用于 drop 事件后过滤非图片文件
 * @param {*} event
 * @returns
 */
export const getDragImgList = event => dragBaseLogic(
    event,
    files => Array.from(files).filter((file: any) => isSupportImageType4ParseCopyImgs(file.type)),
);
